import React from 'react';
import PropTypes from 'prop-types';
import ShareButtonStyled, { SVG } from './ShareButton.styled';

const twitterData = result => {
  if (!result.roundWin) {
    return `https://twitter.com/intent/tweet?url=https%3A%2F%2Fnoodled.app&text=I%20reached%20level%20${result.level +
      1}%20on%20Noodled.%20Think%20you%20can%20do%20better%3F&hashtags=NoodledGame`;
  }
  return `https://twitter.com/intent/tweet?url=https%3A%2F%2Fnoodled.app&text=I%20beat%20level%20${result.level +
    1}%20on%20Noodled%20in%20${result.time}%20seconds%20with%20only%20${
    result.moveCount
  }%20moves%21%20Think%20you%20can%20do%20better%3F&hashtags=NoodledGame`;
};

const ShareButton = ({ type, result }) => {
  if (type === 'facebook') {
    return (
      <ShareButtonStyled
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A//noodled.app"
        facebook
        target="_blank"
        rel="noopener"
        title="Share this on Facebook"
      >
        <SVG
          facebook
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <title>Share on Facebook</title>
          <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
        </SVG>
      </ShareButtonStyled>
    );
  }
  return (
    <ShareButtonStyled
      href={twitterData(result)}
      twitter
      target="_blank"
      rel="noopener"
      title="Share your results on Twitter"
    >
      <SVG
        twitter
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <title>Share on Twitter</title>
        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
      </SVG>
    </ShareButtonStyled>
  );
};

export default ShareButton;

ShareButton.propTypes = {
  type: PropTypes.string.isRequired,
  result: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
};

ShareButton.defaultProps = {
  result: { level: 0, time: 0, moveCount: 0 },
};



// WEBPACK FOOTER //
// ./src/components/atoms/ShareButton/ShareButton.js